import React from 'react';
import classnames from 'classnames';
import { noop, isEmpty, get, defaultTo, isNil, trimStart } from 'lodash';

// local dependencies
import { getLabel } from 'utils/getLabel';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { textareaField as TextareaField } from 'ui/views/generic/textareaField';
 *
 * // render
 * <TextareaField propName='propValue'/>
 */
export const textareaField = ( props ) => {

    // get error message (ref)
    const errorMessage = get( props.error, 'message', null );
    const hasError = ! isEmpty( errorMessage );

    // dynamic class name
    const widgetClassName = classnames( 'ui-textarea-field', props.className, {
        'ui-textarea-field--error': hasError,
    } );

    const textAreaClassname = classnames( 'ui-textarea-field__input__element', props.textAreaClassname );
    const labelClassname = classnames( 'ui-textarea-field__label__text', props.labelClassname, {
        'ui-textarea-field__label__text--no-label': false === props.showLabel
    } );

    return (
        <div className={ widgetClassName }>
            {/* label */}
            <div className='ui-textarea-field__label'>
                {/* label text */}
                <div className={ labelClassname }>{ getLabel( props.label ) }</div>

                {/* required asterisk */}
                {
                    props.required ? (
                        <div className='ui-textarea-field__label__asterisk'>*</div>
                    ) : null
                }
                {
                    ! isNil( props.maxLength ) ? (
                        <div className='ui-textarea-field__label__remaining'>Remaining: { props.maxLength - defaultTo( props.value, '' ).length }</div>
                    ) : null
                }
            </div>


            {/* input */}
            <div className={ 'ui-textarea-field__input' }>
                <textarea
                    type='text'
                    rows={ 4 }
                    className={ textAreaClassname }
                    placeholder={ ! isEmpty( props.placeholder ) ? getLabel( props.placeholder ) : '' }
                    value={ defaultTo( props.value, '' ) }
                    maxLength= { props.maxLength }
                    onChange={ ( event ) => props.onChange( {
                        name: props.name,
                        value: trimStart( event.target.value ),
                    } ) }
                />
            </div>

            {/* error message */}
            {
                hasError ? (
                    <div className='ui-textarea-field__error'>
                        <div className='ui-textarea-field__error__message'>
                            { getLabel( errorMessage ) }
                        </div>
                    </div>
                ) : null
            }
        </div>
    );
};

// set display name
textareaField.displayName = 'textareaField';

// set default props
textareaField.defaultProps = {
    name: null,
    label: null,
    placeholder: null,
    value: '',
    onChange: noop,
    required: false,
    error: {},
    mode: null, // possible values `null`, `readonly`.
};

// prop types
textareaField.propTypes = {};
